import { UseQueryModalReturn } from "../../types";

interface UseMultiSelectQueryModalParams<TOperator> {
  selectedIds: (string | number)[];
  previousIds?: (string | number)[];
  selectedOperator?: TOperator | null;
  initialOperator?: TOperator | null;
  editQueryId?: string;
  existingQueryId?: string | null;
}

export function useMultiSelectQueryModal<TOperator>({
  selectedIds,
  previousIds,
  editQueryId,
  existingQueryId,
}: UseMultiSelectQueryModalParams<TOperator>): UseQueryModalReturn {
  const hasSameSelection =
    selectedIds.length === previousIds?.length &&
    selectedIds.every((id) => previousIds.includes(id));

  const isSubmitDisabled =
    (!editQueryId && !existingQueryId && selectedIds.length === 0) ||
    (!!editQueryId && hasSameSelection) ||
    (!!existingQueryId && hasSameSelection);

  return { isSubmitDisabled };
}
